import React, { useEffect } from "react";
import Output from "./StateOutput";

import { firebase } from "../../Firebase/config";
import { createUserWithEmailAndPassword, sendEmailVerification } from "@firebase/auth";
import { collection, addDoc, query, where, getDocs, deleteDoc, doc, setDoc } from "@firebase/firestore";
import "./StateResultsContainer.css";

const ResultsContainer = ({ filteredstates, state, setState, stateArray, textsearchedstates, setSearchingstate, searchingstate, number, setNumber, newstatearray, setNewstatearray }) => {
  useEffect(() => {
    if(typeof state != "undefined") {
      setSearchingstate(true);
    } else {
      setSearchingstate(false);
    }
  }, [filteredstates, state, setSearchingstate])

  const styles = {
    container: {
      minHeight: 40,
      backgroundColor: "#000",
      display: "flex",
      alignItems: "center",
      marginBottom: 4,
      padding: "4px 8px",
    }
  };

  return (
    <div className="states-scrollable-container">
      {typeof filteredstates != "undefined" &&
        filteredstates.map((info, value) => (
          <div key={value}>
            {searchingstate ?
              <div style={styles.container}>
                <div 
                  onClick={() => { setSearchingstate(false); setState(info.name)}}
                  style={{cursor: 'pointer', marginLeft: 'auto', marginRight: 'auto'}}
                >
                  <Output state={info.name} />
                </div>
              </div>
              : <div></div>}
          </div>
        ))}
    </div>
  );
};

export default ResultsContainer;